import {Component, Injector} from '@angular/core';
import {DriversDialogBaseComponent} from "./drivers-dialog-base/drivers-dialog-base.component";

@Component({
    selector: 'app-create-driver',
    templateUrl: './drivers-dialog-base/drivers-dialog-base.component.html',
    styleUrls: ['./drivers-dialog-base/drivers-dialog-base.component.css'],
    standalone: false
})
export class CreateDriverComponent extends DriversDialogBaseComponent {

  constructor(protected injector: Injector) {
    super(injector);
    this.dialogId = "createDriver";
  }

  public submit() {
    this.model.Id = 0;
    this.model.GroupIds = this.model.Groups;

    this.service.createDriver(this.model).subscribe((res) => {
        this.onCreated.emit();
        this.close();
        this.syncService.NotifyEntityChanged("Driver",this.model.Id);
        super.submit();

      });
  }

}
